import axios, { AxiosInstance } from 'axios';

const axiosInstance: AxiosInstance = axios.create({
  paramsSerializer: (params: Record<string, unknown>) => {
    return Object.entries(params)
      .map(([key, value]) => {
        const json = JSON.stringify(value);
        const encoded = encodeURIComponent(json).replace(/%20/g, '+');
        return `${key}=${encoded}`;
      })
      .join('&');
  },
});

export default axiosInstance;